import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useState, useEffect } from 'react';
// import plusFill from '@iconify/icons-eva/plus-fill';
// import { Link as RouterLink } from 'react-router-dom';
// material
import { useTheme } from '@mui/material/styles';
import {
  Card,
  Table,
  Stack,
  Avatar,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  IconButton,
  Box,
  Divider,
  Button,
  LinearProgress
} from '@mui/material';
// redux
import { useDispatch, useSelector } from '../../../../../../redux/store';
import { deleteUser } from '../../../../../../redux/slices/user';
import { setUserList } from '../../../../../../redux/slices/dagpacket';
// routes
// hooks
import useSettings from '../../../../../../hooks/useSettings';
// components
import Page from '../../../../../Page';
import Label from '../../../../../Label';
import Scrollbar from '../../../../../Scrollbar';
import SearchNotFound from '../../../../../SearchNotFound';
import { UserListHead, UserListToolbar } from '../../../../user/list';
import { firestore } from '../../../../../../contexts/FirebaseContext';
// import { AppLicenciatarios } from '../../components/_dashboard/general-app';
import RoleView from '../../../../user/RoleView';
// import WalletUserView from './WalletUserView';
// import DialogUsuarioEditar from './DialogUsuarioEditar';
import { Icon } from '@iconify/react';
import useAuthUsers from '../../../../../../hooks/useAuthUsers';
import { LoadingButton } from '@mui/lab';
import useEmpaque from '../../../../../../hooks/useEmpaque';
import TraspasoMenu from './TraspasoMenu';
import { fDateTime } from '../../../../../../utils/formatTime';
// import EditMenu from './EditMenu';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: '' },
  { id: 'origenUser', label: 'Origen', alignRight: false },
  { id: 'productoName', label: 'Producto', alignRight: false },
  { id: 'created_at', label: 'Fecha', alignRight: false },
  { id: 'cantidad', label: 'Cantidad', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false }
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user?.displayName?.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

// const userList = [];

export default function ListaTraspasos({ userData }) {
  const theme = useTheme();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [dataTable, setDataTable] = useState([]);
  //   const { userList } = useSelector((state) => state.dagpacket);
  //   const [userListLocal, setUserListLocal] = useState([]);
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('name');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // const { currentUser } = useAuthUsers();
  const currentUser = userData;

  const { recepcionarProductos } = useEmpaque();

  useEffect(() => {
    function getData() {
      firestore
        .collection('emp_traspasos')
        .where('destinoId', '==', currentUser.almacenId)
        .orderBy('created_at', 'desc')
        .onSnapshot((query) => {
          //   if (query.exists) {
          const arrData = [];
          query.forEach((item) => {
            arrData.push({ id: item.id, ...item.data() });
          });

          console.log(arrData);
          setDataTable(arrData);
          //   }
        });
    }

    getData();
  }, [currentUser.almacenId]);

  // const handleRecepcionar = async (idOrigen, idDestino, traspasoItem) => {
  //   await recepcionarProductos(idOrigen, idDestino, traspasoItem);
  // };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = dataTable.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
    console.log(filterName);
  };

  const handleDeleteUser = (userId) => {
    dispatch(deleteUser(userId));
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataTable.length) : 0;

  const filteredDataTable = applySortFilter(dataTable, getComparator(order, orderBy), filterName);

  const isUserNotFound = filteredDataTable.length === 0;

  // const asd = () => {
  //   firestore.collection('empaquetado').doc("xNxbNyux8QuPCdgFOpN2").delete();
  // };

  return (
    <Card>
      {/* <Button onClick={asd}>asd</Button> */}
      <Box padding="10px 15px">
        <Typography variant="subtitle1" fontSize="25px">
          Traspasos
        </Typography>
        <Divider />
      </Box>
      {loading && <LinearProgress />}
      <UserListToolbar numSelected={selected.length} filterName={filterName} onFilterName={handleFilterByName} />

      <Scrollbar>
        <TableContainer sx={{ minWidth: 800 }}>
          <Table>
            <UserListHead
              order={order}
              orderBy={orderBy}
              headLabel={TABLE_HEAD}
              rowCount={dataTable.length}
              numSelected={selected.length}
              onRequestSort={handleRequestSort}
              onSelectAllClick={handleSelectAllClick}
              checkboxOption={false}
            />
            <TableBody>
              {filteredDataTable.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                const {
                  id,
                  origenUser,
                  origenId,
                  destinoId,
                  productoImg,
                  cantidad,
                  productoName,
                  created_at,
                  status = 'active'
                } = row;
                const isItemSelected = selected.indexOf(id) !== -1;
                return (
                  <TableRow
                    hover
                    key={id}
                    tabIndex={-1}
                    role="checkbox"
                    selected={isItemSelected}
                    aria-checked={isItemSelected}
                  >
                    <TableCell>
                      <TraspasoMenu dataItem={row} setLoading={setLoading} />
                    </TableCell>
                    <TableCell>{origenUser}</TableCell>
                    <TableCell align="left">{productoName}</TableCell>
                    <TableCell align="left">{fDateTime(created_at.toDate())}</TableCell>
                    <TableCell align="left">{cantidad}</TableCell>
                    <TableCell align="left">{status}</TableCell>
                    {/* <TableCell align="left">
                      <TraspasoMenu />
                    </TableCell> */}
                  </TableRow>
                );
              })}
              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
            {isUserNotFound && (
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                    <SearchNotFound searchQuery={filterName} />
                  </TableCell>
                </TableRow>
              </TableBody>
            )}
          </Table>
        </TableContainer>
      </Scrollbar>

      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={filteredDataTable.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Card>
  );
}
